import React from "react";

function EmailSentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="22"
      fill="none"
      viewBox="0 0 54 22"
    >
      <path
        fill="#F28E2A"
        fillRule="evenodd"
        d="M24 5.05A5.05 5.05 0 0129.05 0h19a5.05 5.05 0 015.05 5.05v11a5.05 5.05 0 01-5.05 5.05h-19A5.05 5.05 0 0124 16.05v-11zm5.05-2.95a2.95 2.95 0 00-2.95 2.95v11A2.95 2.95 0 0029.05 19h19A2.95 2.95 0 0051 16.05v-11a2.95 2.95 0 00-2.95-2.95h-19z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#F28E2A"
        fillRule="evenodd"
        d="M51.64 3.918l-10.778 7.33a4.05 4.05 0 01-4.618-.045L25.943 3.907l1.214-1.714 10.3 7.297a1.95 1.95 0 002.224.02L50.46 2.183l1.181 1.736zM1.9 4.1A1.1 1.1 0 013 3h15.1a1.1 1.1 0 010 2.2H3a1.1 1.1 0 01-1.1-1.1zM9 10.1A1.1 1.1 0 0110.1 9h10.5a1.1 1.1 0 010 2.2H10.1A1.1 1.1 0 019 10.1zM0 16a1.1 1.1 0 011.1-1.1h16a1.1 1.1 0 010 2.2h-16A1.1 1.1 0 010 16z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default EmailSentIcon;
